import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';

import { IReckonTelevisionService, LocationsService } from '@era/inroom-sdk';

import { LocationApiLocationsLoaded } from '../stores/locations/locations.actions';
import { AuthorizationActionTypes } from '../stores/user/user.actions';
import { LoadMovies } from '../sub-features/room/media/movie/movies.actions';
import { LoadRadioChannels } from '../sub-features/room/media/radio-channel/radio-channels.actions';
import { LoadTvChannels } from '../sub-features/room/media/tv-channel/tv-channels.actions';

@Injectable()
export class AppEffects {
  private readonly actions$ = inject(Actions);
  private readonly televisionApi = inject(IReckonTelevisionService);
  private readonly locationApi = inject(LocationsService);

  locationsLoadEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthorizationActionTypes.AUTH_API_LOGGED_IN),
      switchMap(() => this.locationApi.getLocations()),
      map((locations) => new LocationApiLocationsLoaded(locations))
    );
  });

  moviesLoadEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthorizationActionTypes.AUTH_API_LOGGED_IN),
      switchMap(() => this.televisionApi.getMovies({ hotelCode: 'ignored', room: 'ignored' })),
      map((movies) => new LoadMovies(movies.Data ?? []))
    );
  });

  tvChannelsLoadEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthorizationActionTypes.AUTH_API_LOGGED_IN),
      switchMap(() => this.televisionApi.getTelevisionChannels({ hotelCode: 'ignored', room: 'ignored' })),
      map((tvChannels) => new LoadTvChannels(tvChannels.Data ?? []))
    );
  });

  radioChannelsLoadEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthorizationActionTypes.AUTH_API_LOGGED_IN),
      switchMap(() => this.televisionApi.getRadioChannels({ hotelCode: 'ignored', room: 'ignored' })),
      map((radioChannels) => new LoadRadioChannels(radioChannels.Data ?? []))
    );
  });
}
